import React, { Component } from 'react';
import axios from "axios";
import env from "../../env";

class Last24h extends Component {
    state = {
        last24h: []
    }

    interval = 3600000;

    componentDidMount() {
        this.getData();
        if (process.env.NODE_ENV !== 'development') {
            setInterval(this.getData, this.interval);
        }
    }

    getData = async () => {
        let response = {};
        let last24h = [];
        let currentUser = {};
        let task = {};
        let timerIds = [];
        for(let i = 0; i < this.props.devTeam.length; i++) {
            currentUser = {};
            response = await axios.get(env.ClickUp.api+'team/'+env.ClickUp.team_id+'/time_entries?start_date='+((new Date().getTime())-86400000)+'&end_date='+(new Date().getTime())+'&assignee='+this.props.devTeam[i].id, {
                headers: {
                    'Authorization': env.ClickUp.access_token,
                    'Content-Type': 'application/json'
                }
            });

            currentUser.name = this.props.devTeam[i].name;
            currentUser.task = [];

            for(let j = 0; j < response.data.data.length; j++) {
                let found = -1;
                for (let k = 0; k < currentUser.task.length; k++) {
                    if (currentUser.task[k].task_id === response.data.data[j].task.id) {
                        found = k;
                        break;
                    }
                }

                if (found === -1) {
                    //add task
                    task = {
                        timer_id: response.data.data[j].id,
                        title: response.data.data[j].task.name,
                        task_id: response.data.data[j].task.id,
                        duration: parseInt(response.data.data[j].duration),
                        task_location: response.data.data[j].task_location
                    }
                    currentUser.task.push(task);
                } else {
                    currentUser.task[found].duration += parseInt(response.data.data[j].duration);
                }

                /* timer (workaround for currentStatus */
                timerIds.push({
                    timer_id: response.data.data[j].id, title: response.data.data[j].task.name, task_location: response.data.data[j].task_location
                })
            }
            last24h.push(currentUser);
        }

        this.setState({last24h: last24h});
    }

    render() {
        const timerMaxInDay = 60*60*8*1000;
        const cards = this.state.last24h.map((task, index) => {
            const values = task.task.map((item, idx) => {
                const calculated = ((item.duration * 100) / timerMaxInDay);

                return (
                    <div className="pb-3 border-bottom" key={"each_last24h_"+idx}>
                        <div className="row align-items-center">
                            <div className="col-8">
                                <p className="mb-2">{item.title}</p>
                                <h4 className="mb-0">{new Date(item.duration).toISOString().substr(11, 8)}</h4>
                            </div>
                            <div className="col-4">
                                <div className="text-right">
                                    <div>
                                        {calculated.toFixed(2)} % <i className="mdi mdi-arrow-up text-success ml-1" />
                                    </div>
                                    <div className="progress progress-sm mt-3">
                                        <div className="progress-bar" role="progressbar" style={{"width": parseInt(calculated)+"%",
                                        "ariaValuenow": parseInt(calculated), "ariaValuemin": "0", "ariaValuemax": "100"}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });

            return (
                <div className="col-xl-3" key={"user_last_"+index}>
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title mb-4">{task.name}</h4>
                            <div>
                                {values}
                            </div>
                        </div>
                    </div>
                </div>
            )
        });

        return (
            cards
        );
    }
}

export default Last24h;